import { useMemo } from "react";

import { renderMarkdown } from "./markdown";

/** Rendered view for Markdown, with the source a click away.
 *
 * Instructions are meant to be read, and a code editor shows them as `#` and
 * `**` noise. Preview is the default for .md; editing still happens in Source.
 *
 * Two elements, not one: the outer scrolls and pads, the inner is the measured
 * column. Centring each child instead means every rule that sets a shorthand
 * `margin` silently drops the horizontal auto and that block drifts off axis.
 */
export function MarkdownPane({ source }: { source: string }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return (
    <div className="markdown">
      <div className="markdown-body" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
